import { render, staticRenderFns } from "./OpAdmissonASAM.vue?vue&type=template&id=5828fafa"
import script from "./OpAdmissonASAM.vue?vue&type=script&lang=js"
export * from "./OpAdmissonASAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports